export const ERROR_UNEXPECTED = "Une erreur inattendue s'est produite";
export const ERROR_DELETE = "Echec lors de la suppression";
export const ERROR_UPDATE = "Echec lors de la mise à jour";
export const ERROR_CREATE = "Echec lors de la création";
export const ERROR_NEW_IDS = "Erreur lors de la création d'identifiants";
export const ERROR_DELETE_IDS = "Erreur lors de la supprésion d'identifiants";
export const ERROR_COPY = "Erreur lors de la copie";
export const ERROR_IMPORT = "Erreur lors de l'importation";
export const ERROR_EXPORT = "Une erreur est survenue lors de l'export";
export const ERROR_LOGS = "Erreur lors du chargement des logs";
export const ERROR_RESET = "Erreur lors de la suppression de la base de donnée";

export const WRONG_IDS = "Identifiants incorrect";
export const WRONG_PASSWORD = "Mot de passe invalide";

export const SUCCESS_UPDATE = "Mise à jour réussie";
export const SUCCESS_DELETE = "Suppression réussie";
export const SUCCESS_CREATE = "Création réussite";
export const SUCCESS_NEW_IDS = "Nouveaux identifiants créés avec succés";
export const SUCCESS_DELETE_IDS = "Identifiants supprimés avec succés";
export const SUCCESS_COPY = "Copié dans le presse-papier";
export const SUCCESS_IMPORT = "Étudiants importés avec succès";
export const SUCCESS_RESET = "Base de données supprimée avec succès";
